import { createApiClient } from './client'

export interface CreateBetaInvitationRequest {
  email: string
}

export interface BetaInvitation {
  id: string
  email: string
  invitation_token: string
  invitation_link: string
  status: 'pending' | 'accepted' | 'expired'
  expires_at: string
  accepted_at: string | null
  created_at: string
}

export interface CreateBetaInvitationResponse {
  success: boolean
  message: string
  data: BetaInvitation
}

export interface GetBetaInvitationsResponse {
  success: boolean
  data: BetaInvitation[]
}

export interface GetBetaInvitationByTokenResponse {
  success: boolean
  data: {
    id: string
    email: string
    status: string
    expires_at: string
    created_at: string
  }
}

export interface AcceptBetaInvitationResponse {
  success: boolean
  message: string
  data: {
    id: string
    email: string
    status: string
    accepted_at: string | null
  }
}

export interface ResendBetaInvitationResponse {
  success: boolean
  message: string
  data: BetaInvitation
}

export class BetaInvitationsApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  async createInvitation(data: CreateBetaInvitationRequest): Promise<CreateBetaInvitationResponse> {
    return this.apiClient.post<CreateBetaInvitationResponse>('/beta-invitations', data)
  }

  async getInvitations(): Promise<GetBetaInvitationsResponse> {
    return this.apiClient.get<GetBetaInvitationsResponse>('/beta-invitations')
  }

  async getInvitationByToken(token: string): Promise<GetBetaInvitationByTokenResponse> {
    return this.apiClient.get<GetBetaInvitationByTokenResponse>(`/beta-invitations/${token}`)
  }

  async acceptInvitation(token: string): Promise<AcceptBetaInvitationResponse> {
    return this.apiClient.post<AcceptBetaInvitationResponse>(`/beta-invitations/${token}/accept`)
  }

  async resendInvitation(invitationId: string): Promise<ResendBetaInvitationResponse> {
    return this.apiClient.post<ResendBetaInvitationResponse>(`/beta-invitations/${invitationId}/resend`)
  }
}

